import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { CuentasPorCobrarService } from '../../../../../services/cuentas-por-cobrar.service';

declare var $;
@Component({
  selector: 'app-formulario-mantenimiento',
  templateUrl: './formulario-mantenimiento.component.html',
  styleUrls: ['./formulario-mantenimiento.component.scss']
})
export class FormularioMantenimientoComponent implements OnInit {
    
  public errors: any = {};
  public puntosINPC: any [] = [];
  public periodos: any [] = [];
  public unidadesIncremento: any [] = [];
  public contratos: any [] = [];
  public interes_moratorio: any = {};
  public periodicidad: any = {};
  public interes_moratorio_unidad: any = {};
  public inpc_puntos: any = {};
  public usar_renta: boolean = false;
  public concepto:any = {};
  public conceptos:any = [];
  public loading_conceptos:boolean = false;


  @Output() mantenimientoGuardado: EventEmitter<any> = new EventEmitter;
  @Input() public contrato: any={};
  @Input() public mantenimiento: any={};

  constructor(public cuentasPorCobrarService: CuentasPorCobrarService) {
  }

  ngOnInit() {
    this.loadPuntosINPC();
    this.loadPeriodos();
    this.loadUnidadesIncremento();
    this.loadConceptos();
  }

  loadPuntosINPC(){
    for(var i=1; i<=10; i++){
      this.puntosINPC.push({id: i, cantidad: i});
    }
  }

  loadConceptos(){
    this.loading_conceptos = true;
    this.cuentasPorCobrarService.getAllConceptosVisiblesEnContratos()
    .subscribe(
      (response)=>{
        let content = response.json().content;
        this.conceptos = content;
        this.loading_conceptos = false;
      },
      (error)=>{
        this.loading_conceptos = false;
      }
    );
  }

  loadPeriodos(){
    this.periodos.push({id: 1, descripcion: "Semanal"});
    this.periodos.push({id: 2, descripcion: "Quincenal"});
    this.periodos.push({id: 3, descripcion: "Mensual"});
    this.periodos.push({id: 4, descripcion: "Bimestral"});
    this.periodos.push({id: 5, descripcion: "Trimestral"});
    this.periodos.push({id: 6, descripcion: "Semestral"});
    this.periodos.push({id: 7, descripcion: "Anual"});
    this.changePeriodicidad(this.periodos[2]);
  }

  loadUnidadesIncremento(){
    this.unidadesIncremento.push({id:"DIAS",descripcion:"DÍAS"});
    this.unidadesIncremento.push({id:"SEMANAS",descripcion:"SEMANAS"});
    this.unidadesIncremento.push({id:"MESES",descripcion:"MESES"});
    this.changeInteresMoratorioUnidad(this.unidadesIncremento[0]);
  }
  
  loadMantenimiento(mantenimiento){
    this.mantenimiento = mantenimiento;

    if(this.mantenimiento.periodicidad){
      for(var i=0;i<this.periodos.length;i++){
        var periodo = this.periodos[i];
        if(periodo.descripcion.toLowerCase()==this.mantenimiento.periodicidad.toLowerCase()){
          this.periodicidad = periodo;
          this.changePeriodicidad(this.periodicidad);
          break;
        }
      }
    }

    if(this.mantenimiento.id_concepto && this.mantenimiento.id_concepto!=null && this.mantenimiento.id_concepto!=0){
      for(var i=0;i<this.conceptos.length;i++){
        var concepto = this.conceptos[i];
        if(concepto.idConceptos==this.mantenimiento.id_concepto){
          this.concepto = concepto;
        }
      }
    }else{
      this.concepto = {};
    }

    if(this.mantenimiento.incremento_inpc===true && this.mantenimiento.puntos_inpc_renovacion){
      for(var i=0;i<this.puntosINPC.length;i++){
        var puntaje_inpc = this.puntosINPC[i];
        if(puntaje_inpc.cantidad===this.mantenimiento.puntos_inpc_renovacion){
          this.inpc_puntos = puntaje_inpc;
        }
      }
    }
  }
  agregarInteresMoratorio(){
    this.mantenimiento.intereses_moratorios.push(this.interes_moratorio);
    this.interes_moratorio = {};
    this.changeInteresMoratorioUnidad(this.unidadesIncremento[0]);
  }

  guardarMantenimiento(){
    if(!this.validar()) return false;
    //Enviar mantenimiento al padre para que la agregue a su arreglo de mantenimientos y al server
    if(this.mantenimientoGuardado){
      this.mantenimientoGuardado.emit(this.mantenimiento);
      this.mantenimiento = {
        intereses_moratorios: [],
        incremento_inpc: false,
        activo: true,
        periodicidad: {}
      };
    }
  }

  validar(){
    var valid = true;
    this.errors = [];
    this.errors = this.cuentasPorCobrarService.validarInfoMantenimiento(this.mantenimiento);
    if (!$.isEmptyObject(this.errors)) {
      valid = false;
    }
    return valid;
  }

  eliminarInteresMoratorio(index){
    for(var i=0;i<this.mantenimiento.intereses_moratorios.length; i++){
      if(i == index){
        this.mantenimiento.intereses_moratorios.splice(i,1);
      }
    }
  }

  changePeriodicidad($event){
    this.periodicidad = $event;
    this.mantenimiento.periodicidad = this.periodicidad.descripcion;
  }

  changeConceptoSelected($event){
    this.concepto = $event;
    this.mantenimiento.id_concepto = this.concepto.idConceptos;
  }

  changeInteresMoratorioUnidad($event){
    this.interes_moratorio_unidad = $event;
    this.interes_moratorio.unidad = this.interes_moratorio_unidad.id;
  }

  changeINPCPuntaje($event){
    this.inpc_puntos = $event;
    this.mantenimiento.puntos_inpc_renovacion = this.inpc_puntos.cantidad;

  }

  loadContrato(){
    //Por defecto, ponerle a la renta el inicio y fin del contrato
    this.mantenimiento.fecha_inicio = this.contrato.fecha_inicio;
    this.mantenimiento.fecha_fin = this.contrato.fecha_fin;
  }
}


// WEBPACK FOOTER //
// ./src/app/components/contratos/agregar-contrato/listado-mantenimientos/formulario-mantenimiento/formulario-mantenimiento.component.ts